import addServiceClicked from "../events/add-event-clicked.js";
import eventDeleted from "../events/event-deleted.js";
import eventCreated from "../events/event-created.js";
import eventUpdated from "../events/event-updated.js";
import fileInputted from "../events/file-inputted.js";
import fileSent from "../events/file-sent.js";
import progressReceived from "../events/progress-received.js";
import reorderBtnClicked from "../events/reorder-btn-clicked.js";
import eventsReordered from "../events/events-reordered.js";
function makeEventRouter() {
    const router = {
        'add-event-clicked': addServiceClicked,
        'reorder-btn-clicked': reorderBtnClicked
    };
    const routerWithData = {};
    const formRouterWithData = {
        'form-created': eventCreated,
        'form-updated': eventUpdated,
        'form-deleted': eventDeleted,
        'entities-reordered': eventsReordered
    };
    const fileRouterWithData = {
        'file-inputted': fileInputted,
        'file-sent': fileSent,
        'progress-received': progressReceived
    };
    return Object.freeze({
        get,
        getWithData,
        getFormActionWithData,
        getFileActionWithData
    });
    function get(action) {
        return router[action];
    }
    function getWithData(action) {
        return routerWithData[action];
    }
    function getFormActionWithData(action) {
        return formRouterWithData[action];
    }
    function getFileActionWithData(action) {
        return fileRouterWithData[action];
    }
}
;
const APP_VIEWS = makeEventRouter();
export default APP_VIEWS;
